export default {
  RANK_DATA: [
    { rankLetter: 'A', score: 14000, color: 'gold' },
    { rankLetter: 'B', score: 9000, color: 'gold' },
    { rankLetter: 'C', score: 5000, color: 'gold' },
    { rankLetter: 'D', score: 3000, color: 'silver' },
    { rankLetter: 'E', score: 2000, color: 'silver' },
    { rankLetter: 'F', score: 1000, color: 'silver' },
    { rankLetter: 'G', score: 500, color: 'white' },
    { rankLetter: 'H', score: 0, color: 'black' }
  ]
}



// WEBPACK FOOTER //
// ./src/common/rank.js